import { combineReducers } from 'redux';

import { campaignReducer } from './reducers/campaign';
import { campaignsReducer } from './reducers/campaigns';
import { helpReducer } from './reducers/help';
import pricingReducer, { plansReducer } from './reducers/plans';
import { previewReducer } from './reducers/preview';
import { resourceReducer } from './reducers/resource';
import { ruleReducer } from './reducers/rule';
import { rulesReducer } from './reducers/rules';
import { settingReducer } from './reducers/setting';
import { shopReducer } from './reducers/shop';
import { toastReducer } from './reducers/toast';
import { widgetsReducer } from './reducers/widgets';

export const rootReducer = (state, action) => {
  return combineReducers({
    shop: shopReducer,
    toast: toastReducer,
    plans: plansReducer,
    campaigns: campaignsReducer,
    resource: resourceReducer,
    help: helpReducer,
    campaign: campaignReducer,
    rule: ruleReducer,
    rules: rulesReducer,
    setting: settingReducer,
    preview: previewReducer,
    widgets: widgetsReducer,
    pricing: pricingReducer,
  })(state, action);
};
